import { render, staticRenderFns } from "./tabTradeDetail.vue?vue&type=template&id=368e8c47&"
import script from "./tabTradeDetail.vue?vue&type=script&lang=js&"
export * from "./tabTradeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368e8c47')) {
      api.createRecord('368e8c47', component.options)
    } else {
      api.reload('368e8c47', component.options)
    }
    module.hot.accept("./tabTradeDetail.vue?vue&type=template&id=368e8c47&", function () {
      api.rerender('368e8c47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/tabTradeDetail.vue"
export default component.exports